import { Identities } from '@/features/Auth/auth.types'
import { create } from '@/store/store'
import { devtools } from 'zustand/middleware'

interface OtpStore {
  availableFactors: Identities[];
  email: string | null;
  otpChannel: 'WHATSAPP' | 'SMS';
  phone: string | null;
  setAvailableFactors: (availableFactors: Identities[]) => void;
  setEmail: (email: string) => void;
  setOtpChannel: (channel: 'WHATSAPP' | 'SMS') => void;
  setPhone: (phone: string) => void;
  setType: (type: string) => void;
  type: string | null;
}

export const useOtpStore = create<OtpStore>()(
  devtools(
    (set) => ({
      email: null,
      setEmail: (email: string) => set(() => ({ email }), false, 'setEmail'),
      phone: null,
      setPhone: (phone: string) => set(() => ({ phone }), false, 'setPhone'),
      type: null,
      setType: (type: string) => set(() => ({ type }), false, 'setType'),
      availableFactors: [],
      setAvailableFactors: (availableFactors: Identities[]) => set(() => ({ availableFactors }), false, 'setAvailableFactors'),
      otpChannel: 'SMS',
      setOtpChannel: (channel: 'WHATSAPP' | 'SMS') => set(() => ({ otpChannel: channel }), false, 'setOtpChannel'),
    }),
    {
      name: 'useOtpStore',
    },
  ),
)
